import { gql } from "@apollo/client";

export const GET_INDUSTRY_LIST = gql`
  query Query {
    industryList {
      blsIndustryId
      title
      description
    }
  }
`;

export const GET_INDUSTRY = gql`
  query Query($getIndustryBlsIndustryId: String!) {
    getIndustry(blsIndustryId: $getIndustryBlsIndustryId) {
      occupations {
        occupationId
        blsOccupationId
        title
        jobZoneId
      }
      industry {
        blsIndustryId
        title
        description
        projectedOpenings
      }
      employment
      hourlyMedianWage
      occupationAnnualWageMap {
        seriesId
        value
        blsIndustryId
        blsOccupationId
      }
      annualMedianWage
    }
  }
`;

export const SEARCH_OCCUPATION = gql`
  query Query(
    $searchOccupationSearch: String
    $searchOccupationPreparationNeeded: [Int]
    $searchOccupationMinAnnualWage: Int
  ) {
    searchOccupation(
      search: $searchOccupationSearch
      preparationNeeded: $searchOccupationPreparationNeeded
      minAnnualWage: $searchOccupationMinAnnualWage
    ) {
      occupations {
        occupationId
        blsOccupationId
        jobTitleSamples
        title
        jobZoneId
      }
      industryList {
        blsIndustryId
        title
      }
      industryOccupationMap {
        blsOccupationId
        blsIndustryId
        occupationId
      }
      occupationBlsSeriesMap {
        seriesId
        value
        blsIndustryId
        blsOccupationId
      }
    }
  }
`;

export const GET_OCCUPATION = gql`
  query Query(
    $getOccupationOccupationId: String!
    $getOccupationBlsIndustryId: String!
  ) {
    getOccupation(
      occupationId: $getOccupationOccupationId
      blsIndustryId: $getOccupationBlsIndustryId
    ) {
      occupation {
        occupationId
        title
        blsOccupationId
        description
        jobTitleSamples
        projectedOpenings
        projectedGrowth
        projectedGrowthPercent
        workContexts {
          id
          related
          name
          description
          score {
            scale
            important
            value
          }
          response {
            percentage
            name
          }
        }
        workActivities {
          id
          related
          description
          name
          score {
            scale
            important
            value
          }
        }
        detailedWorkActivities {
          id
          related
          name
        }
        education {
          name
          score {
            important
            scale
            value
          }
          description
        }
        skills {
          id
          related
          name
          description
          score {
            scale
            important
            value
          }
        }
        abilities {
          id
          related
          description
          name
          score {
            scale
            important
            value
          }
        }
        tasks {
          id
          green
          related
          statement
          category
          score {
            scale
            important
            value
          }
        }
        jobZoneId
        jobZone {
          title
          education
        }
        pathway {
          pathwayId
          title
        }
      }
      blsSeriesList {
        seriesId
        value
        blsIndustryId
        blsOccupationId
      }
    }
  }
`;

export const GET_JOBS = gql`
  query Query(
    $zipJobListSearch: String
    $zipJobListLocation: String
    $zipJobListRadiusMiles: Int
    $zipJobListDaysAgo: Int
    $zipJobListJobsPerPage: Int
    $zipJobListPage: Int
  ) {
    zipJobList(
      search: $zipJobListSearch
      location: $zipJobListLocation
      radiusMiles: $zipJobListRadiusMiles
      daysAgo: $zipJobListDaysAgo
      jobsPerPage: $zipJobListJobsPerPage
      page: $zipJobListPage
    ) {
      success
      totalJobs
      jobs {
        source
        id
        name
        snippet
        category
        postedTime
        postedTimeFriendly
        url
        location
        city
        state
        country
        salarySource
        buyerType
        hasZipapply
        jobAge
        company
      }
    }
  }
`;
